var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.8328 2.95312C39.6922 3.1875 40.3172 3.89062 40.3172 4.75C40.3172 24.8281 24.0672 41 4.06719 41C3.12969 41 2.42656 40.4531 2.19219 39.5938L0.317188 31.4688C0.160938 30.6094 0.551563 29.6719 1.41094 29.2812L10.1609 25.5312C10.9422 25.2188 11.8016 25.4531 12.3484 26.0781L16.2547 30.8438C22.3484 27.9531 27.2703 22.9531 30.0828 17.0156L25.3172 13.1094C24.6922 12.5625 24.4578 11.7031 24.7703 10.9219L28.5203 2.17188C28.9109 1.3125 29.8484 0.84375 30.7078 1.07812L38.8328 2.95312Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSymbol);
export default __webpack_public_path__ + "static/media/phoneSymbol.7512968d680c9b978b001513436c1d09.svg";
export { ForwardRef as ReactComponent };